import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Env, Paths } from "../../../common/constants";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import { SetSubmittingType } from "../../../redux/global.types";
import { getAccountListing, onAddAccount } from "../services/action";
import { encryptBankDetailsFrontend } from "../../../common/utils/encrypt";

interface Props {
  handleClose?: () => void;
}

const useAddAccountHelper = ({ handleClose }: Props) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();

  const pathName = location.pathname.split("/");
  const path = pathName[pathName.length - 2];

  const isSubscriptionpage = path === "selected-subscription";

  const breadCrumbItems = [
    { label: "My Accounts", path: Paths.ACCOUNT_LIST },
    { label: `Add Account` },
  ];

  const [openConfirmationModal, setOpenConfirmationModal] =
    useState<boolean>(false);

  const addAccountInitialValues = {
    accountType: "",
    bankName: "",
    accountNumber: "",
    routingNumber: "",
  };

  const accountTypeOptions = ["checking", "savings"];

  const handleCancel = () => {
    if (isSubscriptionpage) {
      if (handleClose) handleClose();
    } else navigate(-1);
  };

  const handleOpenConfirmationModal = () => setOpenConfirmationModal(true);
  const handleCloseConfirmationModal = () => setOpenConfirmationModal(false);

  const handleSubmit = async (
    values: typeof addAccountInitialValues,
    { setSubmitting }: { setSubmitting: SetSubmittingType },
  ) => {
    try {
      const encryptedData = encryptBankDetailsFrontend(
        values,
        Env.ACCOUNT_PUBLIC_KEY,
      );

      dispatch(
        onAddAccount(encryptedData, setSubmitting, () => {
          if (isSubscriptionpage) {
            dispatch(getAccountListing());
            if (handleClose) handleClose();
          } else navigate(Paths.ACCOUNT_LIST);
        }),
      );
    } catch (error) {
      console.error("Error submitting the form:", error);
    }
  };

  return {
    breadCrumbItems,
    isSubscriptionpage,
    accountTypeOptions,
    openConfirmationModal,
    addAccountInitialValues,

    handleCancel,
    handleSubmit,
    handleOpenConfirmationModal,
    handleCloseConfirmationModal,
  };
};

export default useAddAccountHelper;
